// Collection-page "in stock" availability toggle; hides cards whose data-in-stock (product-block.liquid) is false.
// <availability-filter> is a custom element so the sticky mobile-copy utility bar clone (theme.js) re-inits itself via connectedCallback.
;(() => {
  const MAX_FILTERED_OUT_SAMPLES = 12
  const HIDDEN_CLASS = 'availability-filter-hidden'
  const AFTER_ATTR = 'availabilityFilterAfter'

  // Keyed by section id; shared with the sticky-copy clone.
  const activeBySection = {}

  // Points the card's link at its first in-stock variant so the PDP doesn't default to an unavailable one.
  function updateProductLink(card, isActive) {
    const variantUrl = card.dataset.availableVariantUrl
    if (!variantUrl) return
    card.querySelectorAll('.product-link, .quickbuy-toggle').forEach((el) => {
      if (!el.dataset.defaultHref) el.dataset.defaultHref = el.href
      el.href = isActive ? variantUrl : el.dataset.defaultHref
    })
  }

  function applyFilter(productList, isActive) {
    // [data-product-id] excludes grid-promotion-block.
    productList.querySelectorAll('.product-block[data-product-id]').forEach((card) => {
      updateProductLink(card, isActive)
      if (!isActive) {
        card.classList.remove(HIDDEN_CLASS)
        return
      }
      card.classList.toggle(HIDDEN_CLASS, card.dataset.inStock !== 'true')
    })
    CollectionFilterShared.repositionPromoBlocks(productList, HIDDEN_CLASS, AFTER_ATTR)
    CollectionFilterShared.hideOrphanedPromoBlocks(productList, isActive, HIDDEN_CLASS)

    const root = productList.closest('[data-section-type="collection-template"]')
    const paginationRow = root && root.querySelector('.pagination-row')
    if (paginationRow) paginationRow.classList.toggle('availability-filter-hide-pagination', isActive)

    CollectionFilterShared.updateFilteredOutSamples(productList, HIDDEN_CLASS, MAX_FILTERED_OUT_SAMPLES)
  }

  class AvailabilityFilterToggle extends HTMLElement {
    connectedCallback() {
      const filterEl = this
      // The sticky clone only copies .utility-bar, not .product-list, so reach up to the real section for it.
      const section = this.closest('[data-section-type="collection-template"]')
      // Looked up on each use; ajax filtering swaps in a new .product-list that the sticky clone must follow.
      const getProductList = () => section && section.querySelector('.product-list')
      if (!getProductList()) return

      const sectionId = section.dataset.sectionId
      const toggle = filterEl.querySelector('[data-availability-filter-toggle]')
      if (!toggle) return

      const isActive = () => Boolean(activeBySection[sectionId])
      const setActive = (value) => {
        activeBySection[sectionId] = value
      }

      function ensureLoaded() {
        const productList = getProductList()
        return CollectionFilterShared.loadAllPages(sectionId, productList).then(() => {
          CollectionFilterShared.tagPromoPositions(productList, AFTER_ATTR)
        })
      }

      // Prefetch on hover/focus.
      toggle.addEventListener('mouseenter', () => ensureLoaded())
      toggle.addEventListener('focus', () => ensureLoaded())

      toggle.addEventListener('click', () => {
        const nextActive = !isActive()
        setActive(nextActive)
        toggle.setAttribute('aria-pressed', String(nextActive))
        CollectionFilterShared.updateButtonLabel(filterEl, nextActive, '.availability-filter__button-text')

        // Apply instantly, then reapply once the rest of the pages have loaded.
        applyFilter(getProductList(), nextActive)
        ensureLoaded().then(() => applyFilter(getProductList(), isActive()))
      })

      toggle.setAttribute('aria-pressed', String(isActive()))
      CollectionFilterShared.updateButtonLabel(filterEl, isActive(), '.availability-filter__button-text')

      // Reapply after an ajax swap replaces the grid. The utility bar is swapped before the grid, so wait a microtask
      // for the rest of the swap to finish; otherwise this would filter the outgoing grid. Page 1 is filtered right away
      // (later pages only append below it); any other page keeps the loading state until every page is in, so
      // unmatched products never flash up.
      if (isActive()) {
        queueMicrotask(() => {
          const productList = getProductList()
          if (CollectionFilterShared.isFirstPage(productList)) {
            CollectionFilterShared.tagPromoPositions(productList, AFTER_ATTR)
            applyFilter(productList, isActive())
          } else {
            CollectionFilterShared.setGridLoading(productList, true)
          }
          ensureLoaded()
            .then(() => applyFilter(productList, isActive()))
            .finally(() => CollectionFilterShared.setGridLoading(productList, false))
        })
      }
    }
  }

  // Guard against redefinition (dev hot-reload can re-run this script).
  if (!customElements.get('availability-filter')) customElements.define('availability-filter', AvailabilityFilterToggle)
})()
